export default __webpack_public_path__ + "icon_print.76b856a5875cb39d4d84dd1540e46b17.svg";